import React from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import makeStyles from "@material-ui/core/styles/makeStyles";
import PageNumber from "./PageNumber";

const useStyles = makeStyles(() => ({
    paginationAction: {
        flexShrink: 0,
        display: 'flex'
    },
    buttonChangePage: {
        padding: 0
    }
}));

const TablePaginationActions = (props) => {
    const {
        page, rowsPerPage, changePage, totalElements,
        pageValue, changePageInputState, handleChangePage,
        handleKeyDown, isInput, ignoreCount, pageLength
    } = props;

    //get the page size and page length, pageSize > pageLength => next btn disabled
    const classes = useStyles();
    return (
        <div className={classes.paginationAction}>
            <IconButton
                onClick={(event) => changePage(event, 0)}
                className={classes.buttonChangePage}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPageIcon/>
            </IconButton>
            <IconButton
                onClick={(event) => changePage(event, page - 1)}
                className={classes.buttonChangePage}
                disabled={page === 0}
                aria-label="previous page">
                <KeyboardArrowLeft/>
            </IconButton>
            {ignoreCount ? <>&#8734;</> : <PageNumber
                totalElements={totalElements} page={page} pageValue={pageValue}
                changePageInputState={changePageInputState} handleChangePage={handleChangePage}
                handleKeyDown={handleKeyDown} isInput={isInput}
            />}
            <IconButton
                onClick={(event) => changePage(event, page + 1)}
                className={classes.buttonChangePage}
                disabled={ignoreCount ? pageLength < rowsPerPage : page >= Math.ceil(totalElements / rowsPerPage) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight/>
            </IconButton>
            <IconButton
                onClick={(event) => changePage(event, Math.max(0, Math.ceil(totalElements / rowsPerPage) - 1))}
                disabled={ignoreCount ? true : page >= Math.ceil(totalElements / rowsPerPage) - 1}
                className={classes.buttonChangePage}
                aria-label="last page"
            >
                <LastPageIcon/>
            </IconButton>
        </div>
    )
};
TablePaginationActions.propTypes = {
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    totalElements: PropTypes.number,
    changePage: PropTypes.func
};
export default TablePaginationActions